<template>
    <div class="d-flex justify-content-center flex-row flex-nowrap">
        <span
            class="me-4"
            v-if="props.value != null && props.value.Latitude != 0 && props.value.Longitude != 0"
        >
            <ButtonComp
                button-type="Custom"
                class="no-focus"
                icon="fa-map-location-dot"
                :title="$ti('positiondisplay.showposition', { lat: props.value.Latitude, lon: props.value.Longitude })"
                @click="showPosition"
            ></ButtonComp>
        </span>
    </div>
</template>

<script lang="ts" setup>
import type { MapPoint } from '@/objects/generated';
import { ButtonComp, MapComp } from '@/components';
import { $ti } from '@/locize';
import { useDialog } from '@/composeables';
import { MapMarker } from '../Map/MapMarker';
import type { MapTrackData } from '../Map/MapTrackData';

const props = defineProps<{
    value: MapPoint | null;

    /**
     * Optional tracks to show on the map.
     * If not provided, no tracks will be shown.
     */
    tracks?: MapTrackData[];
}>();

const showPosition = () => {
    if (!props.value) {
        console.warn('PositionDisplay: No position provided to showPosition function.');
        return;
    }

    let marker = new MapMarker();
    marker.Point = props.value;
    marker.Type = 'pin';

    useDialog().Ok({
        title: $ti('positiondisplay.showposition', { lat: marker.Point.Latitude, lon: marker.Point.Longitude }),
        body: MapComp,
        componentProps: {
            tracks: props.tracks ?? [],
            mapmarkers: [marker],
            height: 500,
            centerpoint: props.value,
            showmaplabels: true,
        },
        options: { Size: 'lg' },
    });
};
</script>
